<template>
    <img v-if="fileUrl" :src="fileUrl" />
</template>

<script>
import Api2 from "@/services/Api2";
import {Environment} from "@/services/Environment";
export default {
    props: ["src"],
    data() {
        return {
            fileUrl: null,
        };
    },
    created() {
        this.getFileUrl();
    },
    watch: {
        src: {
            handler: function (newValue) {
                if (newValue) {
                    this.getFileUrl();
                }
            }
        }
    },
    methods: {
        getFileUrl() {
            if (this.src && this.src != "") {
                //Stars with https:// and has a bucket in it
                if (this.src.indexOf('storage-bjjlink-core-prod') >= 0 ||
                    this.src.indexOf('bjjlink-elevate-storage') >= 0 ||
                    this.src.indexOf('app-bjjlink-pfp-unprocessed-prod') >= 0 ||
                    this.src.indexOf('app-bjjlink-pfp-unprocessed-dev') >= 0) {
                    //This is a temp solution since the bucket is puboci for now
                    this.fileUrl = this.src;
                    return;
                }
                if (this.src.indexOf('https://bjjlink-pub') == 0) {
                    this.fileUrl = this.src;
                    return;
                }
                if (this.src.indexOf('https:') == 0 && this.src.indexOf('bjjlink') > 0) {
                    //This is the case like above when I am trying to get a signed url 
                    const encodedUrl = encodeURIComponent(this.src);
                    //console.log('Loading signed image: ', this.src)
                    Api2()
                        .getWithCache("content/url/signed/" + encodedUrl, {}, 0)//60 is the time we get the image signed for
                        .then(res => {
                            this.fileUrl = res;
                            //console.log('returned image: ', res)
                        }).catch((e) => {
                            console.log('Error getting signed img: ', this.src)
                            console.log(e);
                        });
                } else {
                    const path = this.src;
                    if (path && path != "" && path.indexOf("https:") == 0) {
                        this.fileUrl = path;//regular image
                    } else if (path.indexOf("userfiles") >= 0) {
                        this.fileUrl = Environment.get("VUE_APP_API_HOST") + "/api/" + path;
                    } else if (path.indexOf("media") >= 0) {
                        this.fileUrl = Environment.get("VUE_APP_API_HOST") + "/api/" + path;
                    }
                    else {
                        Api2()
                            .get(this.src)
                            .then((res) => {
                                this.fileUrl = res.data;
                            }).catch((e) => {
                                console.log('Error getting media img: ', this.src)
                                console.log(e);
                            });
                    }
                }
            }
        },
    },
};
</script>

<style scoped></style>
